export default __webpack_public_path__ + "static/media/maduro3.0fabc9b4.png";